import { PAGE_TITLE_LIMIT } from '../../pages';
import type { Revision } from '../../types';
import { mutations } from '../../utils';

/**
 * Get an unique title for a page (ex: "Page 2")
 */
export function getUniquePageTitle(
    revision: mutations.MutableData<Revision>,
    baseTitle = 'Page',
    forceIndex = false
): string {
    const pagesMap = mutations.get(revision, 'pages');
    const pages = mutations.values(pagesMap);

    const existingPaths = pages.map((p) => mutations.get(p, 'title'));
    const titleSet = new Set(existingPaths);

    if (!forceIndex && !titleSet.has(baseTitle)) {
        return baseTitle;
    }

    const tryWithIndex = (index: number): string => {
        const suffix = ` ${index}`;
        const newPath = `${baseTitle.slice(0, PAGE_TITLE_LIMIT - suffix.length)}${suffix}`;

        if (titleSet.has(newPath)) {
            return tryWithIndex(index + 1);
        }

        return newPath;
    };

    return tryWithIndex(1);
}
